export function removeClassAttributes(string: string): string {
  return string.replace(/class=".+?"/gm, '')
}
